import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewRef, Input} from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { Subscription,Observable,
	BehaviorSubject,	 } from 'rxjs'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ErrorCodes } from '../../../../../constants/ErrorCodes'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, DossierService, StateService, SuiviService,DocumentService } from '../../../../../services'
import {  first  } from 'rxjs/operators'
import { FormAtylBase } from '../../../../../motor-form-atyl/form-atyl-base'
import { FormGroup,FormArray, FormControl } from '@angular/forms'
import { UploadFileDialogComponent } from '../../../layout/dialogs/upload-file-dialog/upload-file-dialog.component'

import { LoadDialogComponent } from '../../..//layout/dialogs/load-dialog/load.component'

const KEY = 'document-listing-in-formulaire'

@Component({
	selector: 'atyl-listing-in-formulaire',
	templateUrl: './document-listing-in-formulaire.component.html',
	styleUrls: ['./document-listing-in-formulaire.component.scss']
})
@Stringable({
	path: 'views/partials/content/listing/document-listing-in-formulaire',
	key: KEY,
})
export class DocumentListingInForm extends BaseDialogComponent implements OnInit, OnDestroy {

	private TYPES = {
		Intervention: 'intervention',
		dossier: 'dossier'
	};

	@StringableValues(KEY) strings: any
	dossier: any;

	listDocuments: any[] = [];
	selectedDocuments: any[] = [];
	existedDocuments: any[] = [];

	subscribtions: Subscription[] = [];
	showList: boolean = false;
	
    showLink: boolean = false;
    demandeFormuLaireID:any;
    loading:boolean=false;
   @Input() loaded:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
    
	constructor(
		private stateService: StateService,
        private documentService: DocumentService,
		dialogService: DialogService,
		@Inject(MAT_DIALOG_DATA) public data: any,
		changeDetectorRef: ChangeDetectorRef,
		private dossierService: DossierService,
		private suiviService: SuiviService,
		dialogRef: MatDialogRef<DocumentListingInForm>
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}
	ngOnInit(): void {
		
		this.loaded.subscribe((ld:boolean)=>{
			  console.log("DocumentListingInForm loaed",ld);
			  if (ld) {
				 this.__get__dossier();
				 this.__get__listDocuments();
				}
		 });
		
		
	}

	ngOnDestroy(): void {
		this.subscribtions.forEach(sub => sub.unsubscribe())
	}

    uploadeDialog(event: MouseEvent, document: any) {
        console.log('this.data:',this.data);
        //document = this.formulaires;
        this.dialogService.open(UploadFileDialogComponent, {
            data: {
                document: document,
                slider: {
                    enabled: true,
                    dossier: this.dossier,
                    components: {
                        formulaires: true,
                        interventions: true,
                    }
                }
            },
            width: "40vw",
            minimizable: true,
            maximizable: true,
            draggable: false,
        }, (result: any) => {
            console.log('result:',result);
            if (result && result != "") {
				
				if (result.selectedDocument.demandeID==undefined || result.selectedDocument.demandeID==null)
					result.selectedDocument.demandeID=0;
				
                let document: any = {
                    ID: result.selectedDocument.ID,
                    demandeid: result.selectedDocument.demandeID,
                    document: result.selectedDocument.document,
                    value: result.selectedDocument.value,
                    desciption: null,
                    status: result.currentEtat,
                    parameter: result.selectedDocument.parameter,
					formulaires: result.selectedFormulaires
                }
                document.value.parameter = result.selectedDocument.parameter

                if (result.selectedDocument.description)
                    document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;


                    this.documentService.setDocumentByInstruction(
                        document.demandeid, document, this.dossier.ID).subscribe((res: JSONRpcResponse) => {
                            console.log("after document", res)
                            this.stateService.documentsUpdate(true)

		                    this.__get__listDocuments();
                        })

            }
        });
        this.detecteChanges
    }

    addSelectedDocuments(event: MouseEvent) {
        let demande_formualire_ID;
        if(this.data.documents != undefined){
             demande_formualire_ID = this.data.documents.demandeFormulaire.ID;
        }else{
             demande_formualire_ID = this.data.id;
        }
        let demande_document_ID = [];
        this.selectedDocuments.forEach(result => {
            demande_document_ID.push(result['ID']);
        });

        this.documentService.joinDocumentAtFormulaire(demande_formualire_ID ,demande_document_ID).subscribe((res: JSONRpcResponse) => {
            if(res){
                console.log('res:',res);
            }
        });
        console.log('ID du formulaire:',demande_formualire_ID);
        console.log('ID des Documents:',demande_document_ID);
    }

    RemoveSelectedDocuments(event: MouseEvent) {
        let demande_formualire_ID;
        if(this.data.documents != undefined){
             demande_formualire_ID = this.data.documents.demandeFormulaire.ID;
        }else{
             demande_formualire_ID = this.data.id;
        }
        let demande_document_ID = [];
        this.selectedDocuments.forEach(result => {
            demande_document_ID.push(result['ID']);
        });

        this.documentService.removeDocumentAtFormulaire(demande_formualire_ID ,demande_document_ID).subscribe((res: JSONRpcResponse) => {
            if(res){
                console.log('res:',res);
            }

		    this.__get__listDocuments();
        });
        console.log('ID du formulaire:',demande_formualire_ID);
        console.log('ID des Documents:',demande_document_ID);
    }

	submitSelectedDocuments(event: MouseEvent) {
		switch (this.data.type) {
			case this.TYPES.Intervention:
				this.selectedDocuments.forEach((document: any) => {
					this.subscribtions.push(
						this.suiviService.setOrigine(this.data.intervention.ID, {
							type: 'demande_document',
							id: document.ID
						}).subscribe((res: JSONRpcResponse) => {
							if (res.error) {
								throw new Error(ErrorCodes[res.error.code].long || res.error.message)
							}
						}, (err: Error) => {
							console.error(err)
						}, () => {
							this.dialogRef.close(true)
						})
					)
				});
				break;
		}
	}

	selectOrRemove(document: any) {
        if (this.selectedDocuments.indexOf(document) === -1) {
			this.selectedDocuments.push(document);
		} else {
			this.selectedDocuments.splice(this.selectedDocuments.indexOf(document), 1);
		}

	}

	private __get__listDocuments() {
	    this.loading=true;
	    this.listDocuments=[];
	    this.showList=false;
		this.subscribtions.push(
			this.dossierService.getDocumentList(this.dossier.ID).subscribe((res: JSONRpcResponse) => {

				if (res.result){
					this.listDocuments = res.result;
                    console.log('listDocuments:',this.listDocuments);
				}
				if (res.error) {
					throw new Error(ErrorCodes[res.error.code].long || res.error.message)
				}

                let demande_formualire_ID;
                if(this.data.documents != undefined){
                    demande_formualire_ID = this.data.documents.demandeFormulaire.ID;
                }else{
                    demande_formualire_ID = this.data.id;
                }
                console.log('demande_formulaire.ID:',demande_formualire_ID);
                if (demande_formualire_ID!=undefined)
	                this.documentService.getDocumentsAtFormulaire(demande_formualire_ID).subscribe((docs: JSONRpcResponse) => {
	                    console.log('listDocuments:',this.listDocuments);
	                    if(!docs){
	                        throw new Error(ErrorCodes[res.error.code].long || res.error.message)
	                    }else{
	                        this.listDocuments.forEach(list => {
	                            if(docs.result.includes(list.ID)){
	                                list.checked = true;
	                                this.selectedDocuments.push(list);
	                            }else{
	                                list.checked = false;
	                            }
	                        });
	                    }
	                  
	                });

			}, (err: Error) => {
				console.error(err)
			}, () => {
				this.__existed_documents__()
				this.loading=false;
				this.detecteChanges()

			})
		)
	}
	private __existed_documents__() {
		switch (this.data.type) {
			case this.TYPES.Intervention:
				this.existedDocuments = this.data.intervention.origines.documents
				break
		}
		const existed_ids = this.getDemandeDocumentsIds(this.existedDocuments)
		for (let index = 0; index < this.listDocuments.length; index++) {
			const currentDocument = this.listDocuments[index]
			if (existed_ids.includes(currentDocument.ID)) {
				currentDocument.existed = true
			}
		}
		this.showList = this.listDocuments.length > 0 && this.listDocuments.length > this.existedDocuments.length
	}


	private __get__dossier() {
		if (this.data) {
			
			if(this.data.documents != undefined){
	              this.demandeFormuLaireID = this.data.documents.demandeFormulaire.ID;
	        }else{
	              this.demandeFormuLaireID = this.data.id;
	        }
			
			
			
			this.showLink=( this.demandeFormuLaireID!=undefined &&  this.demandeFormuLaireID );
			if (this.data.dossier) {
				this.dossier = this.data.dossier
				return
			}
			
			this.stateService.dossier.subscribe((dossier: any) => {
				if (dossier) {
					this.dossier = dossier
				} else {
					throw new Error('Dossier is not defined')
				}
			})
		} else {
			throw new Error('data is not defined')
		}
	}

	private detecteChanges() {
		setTimeout(() => {
			if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
				this.changeDetectorRef.detectChanges()
			}
		})
	}

	getDemandeDocumentsIds(documents: any[]) {
		return documents.map((doc: any) => doc.demandeDocument.ID)
	};
	
	download(url: string) {
	        console.log("url download",url)
	       // window.open(url, ' _blank')
		   const dial=this.dialogService.open(LoadDialogComponent, {
		   		               data: {
		   		                   url: url
		   		               },
		   					   height: "95vh",
		   					   width: "80%",
		   					   minimizable: true,
		   					   maximizable: true,
		   					   draggable: true,
		   		           }, (res: any) => {
		   		               
		   		           })
	    }
}
